import React from 'react';
import styled from 'styled-components';
import HamburgerIcon from '@components/dataDisplay/Icons/HamburgerIcon';
import { useRecoilState } from 'recoil';
import { gameUiVisibleState } from '@atom/ui/gameUiState';
// 토글 버튼 스타일
const GameUiToggleButton = styled.button<{ isVisible: boolean }>`
  position: fixed;
  top: 32px;
  right: 24px;
  z-index: 3;

  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid var(--primaryColor);
  background: linear-gradient(135deg, var(--primaryColor), var(--subColor));
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;

  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-5px) scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    cursor: var(--hoverCursorURL), pointer;
  }

  &:active {
    transform: translateY(-5px) scale(0.95);
  }

  @media (max-width: 480px) {
    position: relative;
    width: 42px;
    height: 42px;
    top: unset;
    right: unset;
    margin-left: 8px;
  }
`;

function GameUiToggleBtn() {
  const [isVisible, setIsVisible] = useRecoilState(gameUiVisibleState);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <GameUiToggleButton
      isVisible={isVisible}
      onClick={toggleVisibility}
      title={isVisible ? 'UI 숨기기' : 'UI 보이기'}
    >
      <div style={{ pointerEvents: 'none' }}>
        <HamburgerIcon
          onClick={toggleVisibility}
          isActive={isVisible}
          color="white"
          style={{ marginLeft: 0, transform: 'scale(0.7)' }}
        />
      </div>
    </GameUiToggleButton>
  );
}

export default GameUiToggleBtn;
